/**
 * Interaction-delayed async script loader.
 *
 * Defers execution of third-party / app scripts until the visitor first
 * interacts with the page (or a fallback timer fires), to keep the initial
 * render fast. Rewritten as clean first-party code for the Enfoque fork
 * (previously shipped obfuscated by the theme vendor); behavior preserved.
 *
 * On trigger, for every <script> in the document it:
 *   - promotes a `data-src` attribute to a real `src`;
 *   - recreates any script whose type is the inert `text/javascripts`
 *     sentinel as an executable `text/javascript` script, copying all
 *     attributes and inline code, replacing it in place.
 * Then it fires the `startasyncloading` / `StartAsyncLoading` custom events
 * that snippets/header-content.liquid and app embeds listen for.
 */
(function () {
  var script_loaded = false;

  function loadAsync() {
    if (script_loaded) return;
    script_loaded = true;

    // Iterate a static snapshot: replacing nodes mutates the live collection.
    var scripts = Array.prototype.slice.call(document.getElementsByTagName('script'));

    for (var i = 0; i < scripts.length; i++) {
      var script = scripts[i];

      if (script.getAttribute('data-src') !== null) {
        script.setAttribute('src', script.getAttribute('data-src'));
        delete script.dataset.src;
      }

      if (script.getAttribute('type') === 'text/javascripts') {
        var replacement = document.createElement('script');
        for (var a = 0; a < script.attributes.length; a++) {
          replacement.setAttribute(script.attributes[a].name, script.attributes[a].value);
        }
        replacement.type = 'text/javascript';
        replacement.innerHTML = script.innerHTML;
        script.parentNode.insertBefore(replacement, script);
        script.parentNode.removeChild(script);
      }
    }

    document.dispatchEvent(new CustomEvent('startasyncloading'));
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    }, 900);
  }

  window.addEventListener('scroll', loadAsync, { once: true });
  window.addEventListener('mousemove', loadAsync, { once: true });
  window.addEventListener('touchstart', loadAsync, { once: true });
  window.addEventListener('load', function () {
    setTimeout(loadAsync, 9000);
  });
})();
